// Acceso a fotografías — reglas del Documento Maestro (número final = posición; sin repeticiones)
import manifest from './images_manifest.json';

export const IMG_BASE = `${process.env.PUBLIC_URL || ''}/img`;

function entradas(folder, recursivo = true) {
  const claves = recursivo ? Object.keys(manifest).filter((k) => k === folder || k.startsWith(folder + '/')) : [folder];
  const vistos = new Set();
  const lista = [];
  claves.forEach((k) => {
    (manifest[k] || []).forEach((e) => {
      if (vistos.has(e.file)) return;
      vistos.add(e.file);
      lista.push({ ...e, sub: k });
    });
  });
  lista.sort((a, b) => (a.num === b.num ? a.file.localeCompare(b.file) : a.num - b.num));
  return lista.map((e) => ({ file: e.file, num: e.num, url: `${IMG_BASE}/${e.sub}/${e.file}` }));
}

export function all(folder) {
  return entradas(folder).map((e) => e.url);
}

// Fotografía cuyo nombre termina en un número determinado (regla de posición del documento maestro)
export function pick(folder, num) {
  const e = entradas(folder).find((x) => x.num === num);
  return e ? e.url : null;
}

// Primeras N fotografías disponibles sin repetir (regla universal de galerías)
export function seq(folder, count, exclude = []) {
  const excl = new Set(exclude);
  return entradas(folder)
    .filter((e) => !excl.has(e.file))
    .slice(0, count)
    .map((e) => e.url);
}

export function hasFolder(folder) {
  return entradas(folder).length > 0;
}